import { IconButton, Tooltip } from '@mui/material';
import {  observer } from 'mobx-react';
import React from 'react';
import IconeEsij from '../../img/icones/IconeEsij';
import { Processo } from '../../modelo';
import ProcessoService from '../../services/ProcessoService';
import BotaoAbrirProcessoPJe from '../BotaoAbrirProcessoPJe';

interface IPropsSistemaDeOrigem {
    processo: Processo;
}


class SistemaDeOrigem extends React.Component<IPropsSistemaDeOrigem> {

    abrirEsij = () => {
        ProcessoService.abrirPagina('esij', this.props.processo);
    }

    render() {
        if (this.props.processo.ehPje) {
            return (
                <div className='sumario-processo-origem'>
                    <BotaoAbrirProcessoPJe idProcesso={this.props.processo?.identificadorProcesso} tamanhoBotao='small' />
                </div>
            )
        }

        return (
            <Tooltip title='Abrir processo no eSIJ'>
                <div className='sumario-processo-origem'>
                    <IconButton size='small' onClick={this.abrirEsij} aria-label='Abrir processo no eSIJ. Irá abrir em uma nova página.'>
                        <IconeEsij />
                    </IconButton>
                </div>
            </Tooltip>
        )
    }
}

export default observer(SistemaDeOrigem);
